import React, {useEffect,useState} from 'react';
import VideoMarquee from '../../components/video-marquee';
import MediaBoard from '../../components/mediaboard';
import Roomboard from '../../components/roomboard';
import './small-class.scss';
import useStream from "../../hooks/use-streams";
import VideoPlayer from '../../components/video-player';
import { userDefine} from '../../stores/userdefine';
export default function SmallClass() {
    const {teacher, students, onPlayerClick} = useStream();
    const [plate, setPlate] = useState(userDefine);

  return (
    <div className="room-container" style={{backgroundColor: "#1a2e47"}}>
      <div className="container container-wrapper" >
          <MediaBoard />
        <Roomboard currentActive={'media'} />
      </div>
      <VideoMarquee />
    </div>
  )
}

